// 登录路由
export const loginAction = [
  {
    path: "/login",
    name: "loginIndex",
    component: resolve => require(["@/page/login/loginIndex"], resolve),
  },
  // 第三方登录回调路由
  {
    path: "/getToken",
    name: "getToken",
    component: resolve => require(["@/page/login/getToken"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/loginRouter.js